import React from 'react';
import { observer } from 'mobx-react';
import dashboardSettingsStore from '../../../../stores/dashboard-settings-store';
import { PROFILE_CAPABILITIES } from '../../../../models/ProfileCapabilities';
import PlanApprovalModal from '../../../../pages/home/components/plan-approval-modal/plan-approval-modal';

const PlanApprovalModalGate: React.FC = observer(() => {
    if (!dashboardSettingsStore.areSettingsLoaded) {
        return null;
    }

    const approvalUrl = dashboardSettingsStore.acceptNewPlanUrl;
    const planApprovalUx = dashboardSettingsStore.resolveCapability(PROFILE_CAPABILITIES.PLAN_APPROVAL_UX);

    if (!approvalUrl || !planApprovalUx.isBlockingModalSupported) {
        return null;
    }

    return <PlanApprovalModal approvalUrl={approvalUrl} />;
});

export default PlanApprovalModalGate;
